<template>
  <permission-gate
    moduleKey="tipo-tratado"
    :showNoEditAlert="true"
  >
    <template #default="{ canEdit }">
      <main-breadcrumb
        :items="items"
        showBackButton
      />
      <main-buttons-bar :align="'space-between'">
        <template #left>
          <custom-title>Detalle de tipo de tratado</custom-title>
        </template>
      </main-buttons-bar>
      <detail-container>
        <el-form
          ref="formRef"
          :model="tipoTratado"
          :rules="formRules"
          size="default"
        >
          <el-row class="row-form">
            <el-col :span="8">
              <el-form-item prop="Descripcion">
                <custom-input
                  v-model="tipoTratado.Descripcion"
                  :label="'Descripción'"
                  :settings="{
                    placeholder: 'Ingresar descripción',
                  }"
                />
              </el-form-item>
            </el-col>

            <el-col :span="2">
              <el-form-item>
                <custom-switch
                  v-model="tipoTratado.Activo"
                  label="Activo"
                  :spanColumn="2"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div
          v-if="canEdit"
          class="container"
        >
          <custom-confirm-buttons
            :disabled="false"
            :showLoading="false"
            :confirmText="'Guardar'"
            :cancelText="'Cancelar'"
            @on-cancel="onCancel"
            @on-confirm="onConfirm"
          />
        </div>
      </detail-container>
    </template>
  </permission-gate>
</template>

<script setup>
import {
  ref,
  reactive,
  onBeforeMount,
} from 'vue';
import { storeToRefs } from 'pinia';
import CustomConfirmButtons from '@/shared/components/custom_confirm_buttons.vue';
import CustomTitle from '@/shared/components/custom_title.vue';
import CustomInput from '@/shared/components/custom_input.vue';
import CustomSwitch from '@/shared/components/custom_switch.vue';
import DetailContainer from '@/shared/layout/detail/detail_container.vue';
import MainBreadcrumb from '@/shared/layout/main/main_breadcrum.vue';
import MainButtonsBar from '@/shared/layout/main/buttons_bar/main_buttons_bar.vue';
import { useTipoTratadoStore } from '../stores/tipo_tratado_store.js';
import { useMessageError } from '@/shared/composables/message_error.js';
import { useMessageSuccess } from '@/shared/composables/message_success.js';
import { useLoading } from '@/shared/composables/loading.js';
import { ElNotification } from 'element-plus';
import {
  useRoute,
  useRouter,
} from 'vue-router';
import PermissionGate from '@/shared/components/permission_gate.vue';

const route = useRoute();
const router = useRouter();

const tipoTratadoStore = useTipoTratadoStore();
const { tipoTratado } = storeToRefs(tipoTratadoStore);

const items = [
  { label: 'Inicio', to: '/page/tipo-tratado/list', replace: false },
  { label: 'Edit', to: null, replace: false },
];

const formRef = ref(null);

const formRules = reactive({
  Descripcion: [
    { required: true, message: 'Ingresar descripción del tipo de tratado', trigger: 'change' },
  ],
});

const onCancel = () => {
  tipoTratadoStore.resetTipoTratado();
  router.push('/page/tipo-tratado/list');
};

const onConfirm = async () => {
  formRef.value.validate(async (valid) => {
    if (valid) {
      try {
        useLoading().openLoading();
        await tipoTratadoStore.saveTipoTratado();
        useMessageSuccess().open(`Los datos se han actualizado existosamente!`);
        router.go(-1);
      } catch (err) {
        useMessageError().open(`Ha ocurrido un error al intentar actualizar los datos.`);
      } finally {
        useLoading().closeLoading();
      }
    } else {
      ElNotification({
        title: 'Tipo de tratado',
        message: 'Por favor, revise los campos ingresados.',
        type: 'warning',
      });
    }
  });
};

onBeforeMount(() => {
  if (route.params.id) {
    tipoTratadoStore.findTipoTratadoHTTP(route.params.id);
  }
});
</script>

<style scoped>
.el-form {
  margin-top: 0;
}

.el-form-item {
  margin-top: 0;
  margin-bottom: 0;
}

.container {
  display: flex;
  justify-content: flex-end;
}

.row-form :deep(.el-form-item__content) {
  padding-right: 20px !important;
}
</style>
